import React from "react";
import { Toolbar, Typography } from "@material-ui/core";
import { useToolbarStyles } from "./styles";

function TableToolbar({ title, info, action }) {
  const styles = useToolbarStyles();

  return (
    <Toolbar className={styles.root}>
      <div className={styles.flex}>
        {title ? (
          <Typography
            className={styles.title}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            {title}
          </Typography>
        ) : null}

        {info ? (
          <Typography style={{ width: "100%" }} component="div">
            {info}
          </Typography>
        ) : null}
      </div>

      {action}
    </Toolbar>
  );
}

export default TableToolbar;
